if (!window.htmlVersion) {
  document.body.appendChild(Object.assign(new Image(), {
    src: '/assets/Clear-Site-Data.svg'
  }));
  window.htmlVersion = 1;
}